// extracted by mini-css-extract-plugin
export var button = "Sidebar-module--button--0bfed";
export var link = "Sidebar-module--link--9e911";
export var sidebar = "Sidebar-module--sidebar--9a180";
export var toggle = "Sidebar-module--toggle--e812a";